import { api } from 'services/companiesApi';

export const getEmployeesWithActions = (
	companyId: string,
	hraCompanyGroupId: string,
	employeeIds: string,
) => {
	return api.get(
		`/companies/${companyId}/hra-groups/${hraCompanyGroupId}/employees/actions?employeeIds=${employeeIds}`,
	);
};

export const putEmployeesWithActions = (
	companyId: string,
	hraCompanyGroupId: string,
	data: {
		employeeIds: string[];
		activities: Array<{ actionId: string; status: string }>;
	},
) => {
	return api.put(
		`/companies/${companyId}/hra-groups/${hraCompanyGroupId}/employees/actions`,
		data,
	);
};
